import React from "react";
import { Link, Redirect } from "react-router-dom";
import * as Api from "../api/diet";
import { toast } from "react-toastify";
import { AiFillWarning, AiFillCheckCircle, AiFillStar } from "react-icons/ai";

class Diets extends React.Component {
    state = {
        redirectGenerator: false,
        diets: []
    };

    async componentDidMount() {
        // This binding is necessary to make `this` work in the callback
        this.onDeleteClicked = this.onDeleteClicked.bind(this);
        this.onFavorited = this.onFavorited.bind(this);
        await this.getDietList();
    }

    async getDietList() {
        let diets = await Api.getUserDiets(this.props.user.id);
        if (!diets)
            this.setState({ redirectGenerator: true });
        else
            this.setState({ diets: diets });
    }

    onSubmit(event) {
        event.preventDefault();
    }

    async onDeleteClicked(dietId) {
        try {
            if (window.confirm("Estas seguro?")) {
                await Api.deleteDiet(dietId);
                var array = [...this.state.diets]; // make a separate copy of the array
                var index = array.findIndex(d => d.id === dietId);
                if (index !== -1) {
                    array.splice(index, 1);
                    this.setState({ diets: array });
                    toast.success("Dieta borrada exitosamente");
                }
            }
        } catch {
            toast.error("Hubo un error al borrar la dieta");
        }
    }

    async onFavorited(diet) {
        await Api.makeFavorite(diet.id, !diet.isFavorite);
        
        //var array = [...this.state.diets]; // make a separate copy of the array
        //var index = array.findIndex(d => d.id === diet.id);
        //if (index !== -1) {
        //    let dietData = array[index];
        //    dietData.isFavorite = !dietData.isFavorite;
        //    this.setState({ diets: array });
        //}
        await this.getDietList();
    }

    render() {
        if (this.state.redirectGenerator) {
            return <Redirect to="/Generator" />;
        } else
            return (
                <>
                    <h2> Dietas </h2>
                    <Link to="/Generator" className="btn btn-primary">
                        Generar nueva dieta
                    </Link>
                    <br />
                    <br />
                    <form onSubmit={this.onSubmit}>
                        <table className="table table-sm table-hover">
                            <thead className="table-dark">
                                <tr>
                                    <th style={{ width: "57px", minWidth: "57px" }}/>
                                    <th>Nombre</th>
                                    <th>Valida</th>
                                    <th />
                                    <th />
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.diets.map(diet => {
                                    return (
                                        <tr key={diet.id}>
                                            <td>
                                                <button className={diet.isFavorite ? "" : "showOnHover"} onClick={() => this.onFavorited(diet)}>
                                                    <AiFillStar color='orange' size={20} />
                                                </button>
                                            </td>
                                            <td>{diet.name}</td>
                                            <td>
                                                {diet.isValid ? (
                                                    <AiFillCheckCircle
                                                        color="limegreen"
                                                        size={25}
                                                    />
                                                ) : (
                                                    <AiFillWarning color="red" size={25} />
                                                )}
                                            </td>
                                            <td>
                                                <Link
                                                    to={`/Generator/${diet.id}`}
                                                    className="btn btn-primary btn-sm"
                                                >
                                                    Editar
                                                </Link>
                                            </td>
                                            <td>
                                                <input
                                                    type="button"
                                                    onClick={event => this.onDeleteClicked(diet.id)}
                                                    className="btn btn-danger btn-sm"
                                                    value="Borrar"
                                                />
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </form>
                </>
            );
    }
}
export default Diets;
